<template>
  <v-form
    ref="loginForm"
    class="login-form"
    v-model="isFormValid"
    lazy-validation
    @submit.prevent="submitForm"
    @keyup.native.enter="submitForm"
  >
    <div class="login-form__img-container">
      <img src="@/assets/img/login-form-img.svg" alt="Login image">
    </div>
    <h1 class="login-form__title">{{ title }}</h1>
    <v-text-field
      v-model="user.email"
      class="form-field mb-3"
      :rules="[rules.required, rules.email]"
      validate-on-blur
      dense
      label="Email Address*"
      placeholder="Type email"
    />
    <v-text-field
      v-model="user.password"
      class="form-field"
      :rules="[rules.required]"
      dense
      type="password"
      label="Password*"
      placeholder="Type password..."
    />

    <div class="login-form__actions">
      <v-checkbox v-model="isRememberMeChecked"
        class="mt-0"
        dense
        hide-details
      >
        <template #label>
          <span class="login-form__checkbox-label">Remember me</span>
        </template>
      </v-checkbox>

      <p
        v-if="source === 'client'"
        class="login-form__lost-password"
        @click="openLostPasswordModal"
      >
        Lost password?
      </p>
    </div>

    <v-btn
      class="login-form__submit"
      color="blue"
      x-large
      block
      :min-width="255"
      :loading="isSubmitProccesing"
      type="submit"
    >
      Log in
    </v-btn>
    <p class="login-form__no-account">
      <slot name="no-account"></slot>
    </p>

    <LostPasswordModal v-model="isLostPasswordModalVisible" />
  </v-form>
</template>

<script>
import validationRules from '@/helpers/validators';
import LostPasswordModal from '@/components/LostPasswordModal.vue';

const rules = validationRules;

export default {
  components: {
    LostPasswordModal,
  },

  props: {
    source: {
      type: String,
      required: true,
    },
    redirectName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: 'Log in',
    },
  },

  data() {
    return {
      rules,
      isFormValid: true,
      isSubmitProccesing: false,
      isRememberMeChecked: false,
      isLostPasswordModalVisible: false,
      user: {
        email: '',
        password: '',
      },
    };
  },

  methods: {
    openLostPasswordModal() {
      this.isLostPasswordModalVisible = true;
    },

    submitForm() {
      this.$refs.loginForm.validate();

      if (this.isFormValid) {
        const { email, password } = this.user;
        const { source } = this;
        this.isSubmitProccesing = true;

        const loginParams = {
          email,
          password,
          source,
          remember: this.isRememberMeChecked,
        };
        this.$store.dispatch('auth/login', loginParams)
          .then(() => {
            this.$router.push({ name: this.redirectName });
          })
          .catch(() => {
            this.isSubmitProccesing = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-form {
  background: #fff;
  max-width: 445px;
  margin: 0 auto;
  box-shadow: 0px 2px 4px #00000029;
  border-radius: 8px;
  padding: 16px 20px;

  @include tablet {
    padding: 32px 80px;
  }

  &__title {
    text-align: left;
    margin-bottom: 16px;
    margin-top: 8px;
  }

  &__actions {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__lost-password {
    font-size: 12px;
    color: $color--blue;
    margin-bottom: 0;
    cursor: pointer;
  }

  &__submit {
    margin-bottom: 6px;
    color: white;
  }

  &__checkbox-label {
    font-size: 12px;
    color: #B9BEC4;
  }

  &__no-account {
    font-size: 12px;
    line-height: 14px;
  }
}
</style>
